import { isSupported } from '@/utils.js'

const supported = isSupported()
let languages = [
  {
    culture: 'en-CA',
    name: 'English'
  }
]
let locale = {
  selected: '',
  default: 'en-CA'
}
if (supported === false) {
  languages = [
    {
      'culture': 'en-CA',
      'name': 'English'
    },
    {
      'culture': 'fr-CA',
      'name': 'Français'
    },
    {
      'culture': 'es-MX',
      'name': 'Español'
    }
  ]
  locale.selected = locale.default
}

export const state = {
  acceptedTermsAndConditions: false,
  activeCategory: null,
  advisor: {
    advisorImageUrl: '',
    advisorName: '',
    marketingImageUrl: ''
  },
  categories: [],
  categoryIdMap: {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '5',
    7: '5',
    8: '5',
    9: '5'
  },
  code: '',
  customer: {
    firstName: '',
    isBusiness: false,
    lastName: ''
  },
  customerCommentsLabel: '',
  deadlines: {
    readyBy: null,
    respondBy: null
  },
  dealer: {
    address: '',
    email: '',
    logoUrl: '',
    name: '',
    phone: '',
    smsPhone: '',
    countryId: '',
    currencyCode: ''
  },
  dmpiLinks: {
    enabled: false,
    serviceContractUrl: '',
    nnaCreditCardApplicationUrl: '',
    sunbitServiceFinancingUrl: '',
    topBanner: '',
    bottomBanner: '',
    sunbitBanner: ''
  },
  drawer: false,
  error: '',
  expired: false,
  help: false,
  inspectionReportUrl: '',
  languages,
  loading: {
    getMetadata: false,
    getTax: false,
    logIn: false,
    sendServices: false,
    getStripePaymentMethods: false,
  },
  locale,
  log: {
    clientId: '',
    events: []
  },
  modal: false,
  reason: false,
  reasons: [],
  service: {},
  services: [],
  signature: null,
  slug: '',
  supported,
  tax: {
    previouslyApproved: 0,
    newlyApproved: 0,
    coreCharges: 0
  },
  hazardousMaterialsFee: 0,
  stripePaymentMethods: [],
  token: '',
  topImageUrl: '',
  dealerId: '',
  inspectionLevelMediaUrl: '',
  inspectionLevelMediaUrls: [],
  inspectionLevelMedia: null,
  isDisableDeclineReasons: false,
  isGuestPaymentEnabled: false,
  isSummaryReload: false,
  isReadOnly: false,
  isCompletedByAdvisor: false,
  customerSignature: '',
  guestPaymentSurchargeAmountOnline: 0,
  guestPaymentSurchargeAmountTerminal: 0,
  guestPaymentSurchargeDisclaimer: null,
  guestPaymentSurchargePriceBreakdown: false
}

export default state
